import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Row,
  Col,
  Button,
  Divider,
  message,
  List,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  smallTailFormItemLayout,
} from "./../../utils/Layouts";

import { useSelector } from "react-redux";

import ReportHeading from "../../utils/ReportHeading";
import ReportFooter from "../../utils/ReportFooter";
import moment from "moment";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import axios from "axios";
import numberFormat from "../../utils/numberFormat";
import {
  addKeysToArray,
  onOtherPaymentWithDetailsSearch,
  onTieupSearch,
  onUserSearch,
  onWarehouseSearch,
} from "../../utils/utilities";
import round from "../../utils/round";
import { debounce, sumBy } from "lodash";
import ReactToPrint from "react-to-print";
import {
  DeleteOutlined,
  PrinterOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import { onChange } from "../../utils/form_utilities";
import TextFieldGroup from "../../commons/TextFieldGroup";

import SalesPreviewModal from "./../SalesPreviewModal";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";

const { Content } = Layout;

const url = "/api/sales/";
const title = "Other Payments";

const initialValues = {
  period_covered: [moment().startOf("day"), moment().endOf("day")],
  warehouse: null,
  search_customer_name: "",
  search_branch_reference: "",
  other_payment: null,
};
export default function OtherPaymentListings({ other_set = false, history }) {
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [options, setOptions] = useState({
    dates: [],
    warehouses: [],
    stocks: [],
  });

  const salesPreviewModal = useRef(null);

  const [total_gross_sales, setTotalGrossSales] = useState(0);

  const report = useRef(null);

  const records_column = [
    {
      title: "Date",
      dataIndex: "datetime",
      render: (date, record) => (
        <span>
          {record.footer !== 1 && moment(date).format("M/D/YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Branch",
      dataIndex: ["warehouse", "name"],
      align: "center",
    },
    {
      title: "MIN",
      dataIndex: ["terminal_details", "min"],
      align: "center",
    },
    {
      title: "SI#",
      dataIndex: "sales_id",
      align: "center",
    },
    {
      title: "TRANS#",
      dataIndex: "trans_id",
      align: "center",
    },
    {
      title: "CUSTOMER",
      dataIndex: ["customer", "customer_name"],
      align: "left",
    },
    {
      title: "TIEUP CODE",
      dataIndex: ["customer", "tieup_code"],
      align: "left",
    },

    {
      title: "TYPE",
      dataIndex: ["payments", "online_payments", "depository"],
      align: "center",
    },
    ...(state?.other_payment?.details || []).map((detail) => {
      return {
        title: detail,
        dataIndex: ["payments", "online_payments", "details", detail],
      };
    }),
    {
      title: "AMOUNT",
      dataIndex: ["payments", "online_payments", "amount"],
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "CASHIER",
      dataIndex: ["user", "name"],
      align: "center",
    },
    {
      title: "",
      width: 20,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 && (
            <SnippetsOutlined
              className="pointer"
              onClick={() => salesPreviewModal.current.open(record)}
            />
          )}
        </span>
      ),
    },
    /* {
      title: "",
      width: 30,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 && (
            <PrinterOutlined
              className="pointer"
              onClick={() => this.onReprintSale(record, index)}
            />
          )}
        </span>
      ),
    }, */
  ];

  const getReport = useCallback(
    debounce((form_data) => {
      const is_excel = form_data.is_excel;

      const loading = message.loading("Loading...", 0);
      axios
        .post(`/api/sales/other-payment-sales`, form_data)
        .then((response) => {
          loading();
          if (response.data?.records) {
            return setRecords(response.data.records);
          }

          if (is_excel) {
            return window.open(`/public/reports/${response.data.filename}`);
          }
        })
        .catch((err) => {
          loading();
          message.error("There was an error processing your request");
        });
    }, 300),
    []
  );

  useEffect(() => {
    onOtherPaymentWithDetailsSearch({ value: "", options, setOptions });

    return () => {};
  }, []);

  useEffect(() => {
    const total_gross_sales = sumBy(records, (record_item) =>
      sumBy(record_item.items, (i) => i.gross_sales)
    );
    setTotalGrossSales(total_gross_sales);
    return () => {};
  }, [records]);

  return (
    <Content>
      <SalesPreviewModal ref={salesPreviewModal} />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <div>{state.warehouse?.name}</div>
        <Divider />
        <Row>
          <Col span={12}>
            <RangeDatePickerFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) =>
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }))
              }
              formItemLayout={smallFormItemLayout}
            />
          </Col>
          <Col span={12}>
            <TextFieldGroup
              label="SI#"
              name="search_sales_invoice_no"
              formItemLayout={smallFormItemLayout}
              value={state.search_sales_invoice_no}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setState,
                });
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <SelectFieldGroup
              label="Branch"
              value={state.warehouse?.name}
              onSearch={(value) =>
                onWarehouseSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const warehouse = options.warehouses[index];

                setState((prevState) => ({
                  ...prevState,
                  warehouse,
                }));
              }}
              formItemLayout={smallFormItemLayout}
              data={options.warehouses}
              column="name"
            />
          </Col>
          <Col span={12}>
            <SimpleSelectFieldGroup
              label="Reg. #"
              name="register"
              value={state.register}
              onChange={(value) => {
                onChange({
                  key: "register",
                  value,
                  setState,
                });
              }}
              formItemLayout={smallFormItemLayout}
              options={state.warehouse?.registers || []}
            />
          </Col>
        </Row>
        <Row>
          {/* <Col span={12}>
            <TextFieldGroup
              label="Net Amount"
              name="search_net_amount"
              formItemLayout={smallFormItemLayout}
              value={state.search_net_amount}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setState,
                });
              }}
            />
          </Col> */}
          <Col span={12}>
            <SelectFieldGroup
              label="Other Payment"
              value={state.other_payment?.name}
              onSearch={(value) =>
                onOtherPaymentWithDetailsSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const other_payment = options.other_payments[index];

                setState((prevState) => ({
                  ...prevState,
                  other_payment,
                }));
              }}
              formItemLayout={smallFormItemLayout}
              data={options.other_payments}
              column="name"
            />
          </Col>
          <Col span={12}>
            <SelectFieldGroup
              label="User"
              value={state.search_user?.name}
              onSearch={(value) => onUserSearch({ value, options, setOptions })}
              onChange={(index) => {
                const search_user = options.users[index];

                setState((prevState) => ({
                  ...prevState,
                  search_user,
                }));
              }}
              formItemLayout={smallFormItemLayout}
              data={options.users}
              column="name"
            />
          </Col>
        </Row>
        {/* <Row>
          <Col span={12}>
            <SelectFieldGroup
              label="Tieup"
              value={state.tieup?.name}
              onSearch={(value) => {
                onTieupSearch({ value, setOptions });
              }}
              onChange={(index) => {
                const tieup = options.tieups?.[index] || null;

                onChange({
                  key: "tieup",
                  value: tieup,
                  setState,
                });
              }}
              formItemLayout={smallFormItemLayout}
              data={options.tieups}
              column="name"
            />
          </Col>
          <Col span={12}>
            <TextFieldGroup
              label="Customer Name"
              name="search_customer_name"
              formItemLayout={smallFormItemLayout}
              value={state.search_customer_name}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setState,
                });
              }}
            />
          </Col>
        </Row> */}
        <Row>
          <Col offset={4} span={20}>
            <Form.Item className="field is-grouped">
              <Button
                onClick={() => {
                  if (state.period_covered?.[0] && state?.period_covered?.[1]) {
                    getReport({ ...state });
                  }
                }}
              >
                Search
              </Button>

              <ReactToPrint
                trigger={() => (
                  <Button
                    type="primary"
                    icon={<PrinterOutlined />}
                    className="m-l-1"
                  >
                    Print
                  </Button>
                )}
                bodyClass="print"
                content={() => report.current}
              />
              <Button
                className="m-l-1"
                onClick={() => {
                  if (state.period_covered?.[0] && state?.period_covered?.[1]) {
                    getReport({ ...state, is_excel: true });
                  }
                }}
              >
                Download Excel
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <div ref={report}>
          <div className="report-heading">
            <ReportHeading />
            <span className="has-text-weight-bold">
              {title} - {state.other_payment?.name}
            </span>
            <br />
            {state.period_covered?.[0] &&
              state.period_covered?.[1] &&
              `${moment(state.period_covered?.[0]).format("ll")} - ${moment(
                state.period_covered?.[1]
              ).format("ll")} `}{" "}
            <br />
            Printed By : {auth.user.name} <br />
            Date/Time Printed : {moment().format("LLL")}
          </div>

          {useMemo(() => {
            return (
              <div className="overflow-auto">
                <Table
                  size="small"
                  dataSource={addKeysToArray([
                    ...(records || []),
                    {
                      footer: 1,
                      payments: {
                        online_payments: {
                          amount: sumBy(
                            records,
                            (o) => o.payments?.online_payments?.amount || 0
                          ),
                        },
                      },
                    },
                  ])}
                  columns={records_column}
                  pagination={false}
                  rowClassName={(record, index) => {
                    if (record.footer === 1) {
                      return "footer-summary has-text-weight-bold";
                    }
                  }}
                />
              </div>
            );
          }, [records, records_column])}

          <div className="report-heading m-t-1">
            <ReportFooter />
          </div>
        </div>
      </div>
    </Content>
  );
}
